import { saveContentWorkingConfigFile } from "./api/mappingApi";

export const saveContentFile = async() => {
    const keys = Object.keys(localStorage);
    // let data = {
    //     "BDate": new Date().toLocaleDateString('en-CA',{
    //         year : 'numeric',
    //         month : '2-digit',
    //         day : '2-digit',
    //         hour : '2-digit',
    //         minute : '2-digit',
    //         hour12 : false
    //     }).replace(/-/g,'/').replace(',', ''),
    //     "SoftVer": "1.6.0.1",
    // };
    let data = {};
    keys.filter((k) => k === 'Connections' || k === 'Parameters' || k === 'Events' || k === 'ECURequestPGN' || k === 'ECUReceiveMessages' || k === 'ECUConstantTxMessages' || k === 'HomePage' || k === 'ECUIDDefinitions' || k === 'ECUTransmitMessages' || k === 'Modbus').map((key) => data[key] = localStorage?.getItem(key) ? JSON.parse(localStorage?.getItem(key)) : '');
    let jsonString = JSON.stringify(data,null,2); // In case we want the json output in a readable format takes more space.
    //let jsonString = JSON.stringify(data);
    const formData = new FormData();
    formData.append('uploadFile',new Blob([jsonString],{type:'plain/text'}),'data.txt');
    let result = await saveContentWorkingConfigFile(formData);
    return result;
}


export const checklocalStorageItems = () => {
    const keys   = Object.keys(localStorage);
    const result = keys.some((k) => k === 'Connections' || k === 'Parameters' || k === 'Events' || k === 'ECURequestPGN' || k === 'ECUReceiveMessages' || k === 'ECUConstantTxMessages' || k === 'HomePage' || k === 'ECUIDDefinitions' || k === 'ECUTransmitMessages' || k === 'Modbus' ? true : false);
    return result;
}

export const compareChanges = async(oldArray, newArray) => {

    if (oldArray.length !== newArray.length) {
        return true;
    }
    function areObjectsEqual(oldObj, newObj) {
        const oldKeys = Object.keys(oldObj);
        const newKeys = Object.keys(newObj);
        if (oldKeys.length !== newKeys.length) {
        return false; 
        }
        for (const key of oldKeys) {
        if (!newObj.hasOwnProperty(key) || oldObj[key] !== newObj[key]) {
            return false;
        }
        }
        return true;
    }
    for (let i = 0; i < oldArray.length; i++) {
        const oldObj = oldArray[i];
        const newObj = newArray[i];
        if (!areObjectsEqual(oldObj, newObj)) {
        return true; 
        }
    }
    return false;
}